<template>
  <button v-if="isExAudio" @click="$emit('mute')" class="obituary-audio_button">
    <img
      :src="
        volumeMute
          ? require('@/assets/images/obituary/volume.png')
          : require('@/assets/images/obituary/volume_on.png')
      "
    />
  </button>
</template>

<script>
export default {
  name: "ObituaryAudioButton",
  props: ["obituaryDetail", "volumeMute"],
  computed: {
    isExAudio() {
      return this.obituaryDetail?.Music && this.obituaryDetail?.musicYn;
    }
  }
};
</script>

<style>
.obituary-audio_button {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  background: #d9d9d9;
}
.obituary-audio_button img {
  width: 60%;
}
</style>
